import {
  cond,
  conformsTo,
  divide,
  flow,
  gte,
  placeholder,
  orderBy,
  slice,
  sumBy,
  nth,
  map
} from 'lodash/fp';

export function getTrend(games, sampleSize = -1) {
  if (games.length <= sampleSize) {
    return 0;
  }

  const latestGame = nth(-1, games);
  const pastGame = nth(-1 - sampleSize, games);

  return latestGame.score - pastGame.score;
}

export function getAverage(games, sampleSize = -1) {
  return cond([
    [
      conformsTo({ length: gte(placeholder, sampleSize) }),
      flow(
        orderBy('startTime', 'desc'),
        slice(0, sampleSize),
        sumBy('score'),
        divide(placeholder, sampleSize)
      )
    ]
  ])(games);
}

export function getGames({ games, teamId }) {
  return map(
    gm =>
      gm.homeId === teamId
        ? {
            ...gm,
            isHome: true,
            oppositionAbbr: gm.awayAbbr,
            oppositionId: gm.awayId,
            oppositionName: gm.awayName
          }
        : {
            ...gm,
            isHome: false,
            oppositionAbbr: gm.homeAbbr,
            oppositionId: gm.homeId,
            oppositionName: gm.homeName
          },
    games
  );
}
